export interface Proverb {
  id: string;
  persian: string;
  transliteration: string;
  english: string;
  explanation?: string;
  icon?: string; // emoji or icon name
  audioUrl?: string;
  example?: string;
}

export const proverbs: Proverb[] = [
  {
    id: '1',
    persian: 'کار امروز را به فردا میفکن.',
    transliteration: 'Kār-e emruz rā be fardā miyafkan.',
    english: 'Don’t put off today’s work for tomorrow.',
    explanation: 'Encourages doing tasks promptly and not procrastinating.',
    icon: '📅',
    example: 'وقتی درس نخوندی، یادت بیاد که کار امروز را به فردا نینداز!',
    audioUrl: '/audio/don-t-put-off-today-s-work-for-tomorrow.wav'
  },
  {
    id: '2',
    persian: 'گر صبر کنی ز غوره حلوا سازی.',
    transliteration: 'Gar sabr koni, ze ghure halvā sāzi.',
    english: 'With patience, you can make halva from unripe grapes.',
    explanation: 'Patience brings good results over time.',
    icon: '🍇',
    example: 'برای موفقیت باید صبر داشته باشی؛ گر صبر کنی ز غوره حلوا سازی.',
    audioUrl: '/audio/with-patience-you-can-make-halva-from-unripe-grapes.wav'
  },
  {
    id: '3',
    persian: 'از تو حرکت، از خدا برکت.',
    transliteration: 'Az to harekat, az Khodā barekat.',
    english: 'You make the effort, God gives the blessing.',
    explanation: 'Encourages taking initiative and trusting in divine support.',
    icon: '🕊️',
    example: 'برای رسیدن به هدف باید تلاش کنی؛ از تو حرکت، از خدا برکت.',
    audioUrl: '/audio/you-make-the-effort-god-gives-the-blessing.wav'
  },
  {
    id: '4',
    persian: 'نابرده رنج، گنج میسر نمی‌شود.',
    transliteration: 'Nāborde ranj, ganj moyassar nemishavad.',
    english: 'No pain, no gain.',
    explanation: 'Success requires effort.',
    icon: '💎',
    example: 'اگر می‌خواهی موفق شوی باید زحمت بکشی؛ نابرده رنج، گنج میسر نمی‌شود.',
    audioUrl: '/audio/no-pain-no-gain.wav'
  },
  {
    id: '5',
    persian: 'دو صد گفته چون نیم کردار نیست.',
    transliteration: 'Do sad gofte chon nim kerdār nist.',
    english: 'Two hundred words are not worth half an action.',
    explanation: 'Actions speak louder than words.',
    icon: '🗣️',
    example: 'فقط حرف زدن کافی نیست؛ دو صد گفته چون نیم کردار نیست.',
    audioUrl: '/audio/two-hundred-words-are-not-worth-half-an-action.wav'
  },
  {
    id: '6',
    persian: 'آب که یک جا بماند، می‌گندد.',
    transliteration: 'Āb ke yek jā bemānad, migandad.',
    english: 'Water that stays in one place becomes stagnant.',
    explanation: 'Stagnation leads to problems; keep moving and growing.',
    icon: '💧',
    example: 'در زندگی باید پیشرفت کنی؛ آب که یک جا بماند، می‌گندد.',
    audioUrl: '/audio/water-that-stays-in-one-place-becomes-stagnant.wav'
  },
  {
    id: '7',
    persian: 'سیب از سیب دور نمی‌افتد.',
    transliteration: 'Sib az sib dur nemioftad.',
    english: 'The apple doesn’t fall far from the tree.',
    explanation: 'Children often resemble their parents.',
    icon: '🍏',
    example: 'پسرش هم مثل خودش مهربونه؛ سیب از سیب دور نمی‌افتد.',
    audioUrl: '/audio/the-apple-doesn-t-fall-far-from-the-tree.wav'
  },
  {
    id: '8',
    persian: 'هر که بامش بیش، برفش بیشتر.',
    transliteration: 'Har ke bāmash bish, barfash bishtar.',
    english: 'The higher the roof, the more snow it gets.',
    explanation: 'With greater wealth or status comes more responsibility or problems.',
    icon: '🏠',
    example: 'هر که بامش بیش، برفش بیشتر؛ هرچه مقام بالاتر، مشکلات هم بیشتر.',
    audioUrl: '/audio/the-higher-the-roof-the-more-snow-it-gets.wav'
  },
  {
    id: '9',
    persian: 'تا نباشد چیزکی، مردم نگویند چیزها.',
    transliteration: 'Tā nabāshad chizaki, mardom naguyand chizhā.',
    english: 'Where there’s smoke, there’s fire.',
    explanation: 'Rumors often have some basis in truth.',
    icon: '🔥',
    example: 'شایعه‌ها بی‌دلیل نیستند؛ تا نباشد چیزکی، مردم نگویند چیزها.',
    audioUrl: '/audio/where-there-s-smoke-there-s-fire.wav'
  },
  {
    id: '10',
    persian: 'یک دست صدا ندارد.',
    transliteration: 'Yek dast sedā nadārad.',
    english: 'One hand has no sound.',
    explanation: 'Teamwork is necessary; you can’t do everything alone.',
    icon: '🤝',
    example: 'برای موفقیت باید با هم کار کنیم؛ یک دست صدا ندارد.',
    audioUrl: '/audio/one-hand-has-no-sound.wav'
  },
  {
    id: '11',
    persian: 'بزک نمیر بهار میاد، کمبزه با خیار میاد',
    transliteration: 'Bozak namir, bahār miyād, kambazeh bā khiyār miyād',
    english: 'Little goat, don’t die — spring will come, with melons and cucumbers.',
    explanation: 'Don’t give up hope; better times are coming (often used sarcastically).',
    icon: '💬',
    example: '– هنوز امید داره که پولدار میشه؟\n– آره! بزک نمیر بهار میاد!'
  },
  {
    id: '12',
    persian: 'آش کشک خاله‌ست، بخوری پاته، نخوری پاته',
    transliteration: 'Āsh-e kashk-e khāleh-st, bokhori pāte, nakhori pāte',
    english: 'It’s Auntie’s whey soup — whether you eat it or not, you\'re in trouble.',
    explanation: 'You have no choice; either way, you’re stuck.',
    icon: '💬',
    example: '– باید باهاش همکاری کنم، حتی اگه خوشم نمیاد.\n– خب، آش کشک خاله‌ست!'
  },
  {
    id: '13',
    persian: 'از این ستون به آن ستون فرجه است',
    transliteration: 'Az in sotoon be ān sotoon forjeh-st',
    english: 'From this column to the next, there’s a reprieve.',
    explanation: 'Delaying might bring a solution; stalling might help.',
    icon: '💬',
    example: '– هنوز فرصت هست که تصمیم بگیری.\n– آره، از این ستون به آن ستون فرجه است.'
  },
  {
    id: '14',
    persian: 'مار گزیده از ریسمان سیاه و سفید می‌ترسه',
    transliteration: 'Mār-gazideh az rismān-e siyāh o sefid mitarse',
    english: 'One bitten by a snake fears even a black-and-white rope.',
    explanation: 'Someone who has experienced something bad becomes overly cautious.',
    icon: '💬',
    example: '– چرا با کسی دیگه وارد رابطه نمیشه؟\n– مار گزیده‌ست دیگه.'
  },
  {
    id: '15',
    persian: 'دل به دل راه داره',
    transliteration: 'Del be del rāh dāre',
    english: 'There is a road between hearts.',
    explanation: 'People in love or connected emotionally can sense each other\'s feelings.',
    icon: '💬',
    example: '– داشتم بهت فکر می‌کردم، تو زنگ زدی!\n– دل به دل راه داره!'
  },
  {
    id: '16',
    persian: 'زیرآب کسی رو زدن',
    transliteration: 'Zir-e āb-e kasi ro zadan',
    english: 'To hit someone’s underwater line.',
    explanation: 'To backstab someone or sabotage them secretly.',
    icon: '💬',
    example: '– چرا اخراجش کردن؟\n– یکی زیرآبشو زده بود.'
  },
  {
    id: '17',
    persian: 'مرغ همسایه غازه',
    transliteration: 'Morgh-e hamsāyeh ghāze',
    english: 'The neighbor’s chicken is a goose.',
    explanation: 'Other people’s possessions always seem better.',
    icon: '💬',
    example: '– همش فکر می‌کنه خونه مردم بهتره.\n– خب، مرغ همسایه غازه!'
  }
]; 